import React, { ReactElement } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Variant } from '@bucketplace/common';
import { MEDIA_QUERY, useResponsive } from '@bucketplace/design-system';
import { Grid, GridItem } from '@bucketplace/design-system/bds';

import { ExhibitionProductCard } from '../ExhibitionProductCard';
import { ExhibitionList } from './types';

export function ThreeColList({
  disableVerticalPadding,
  storeItemList,
  badgeType,
  useBuyButton,
  logData,
}: ExhibitionList): ReactElement {
  const { breakpoint } = useResponsive();
  const isMobile = breakpoint === 'mobile';

  const getVariant = (sellingPrice: number, type: 'Production' | 'Deal'): Variant => {
    if (!isMobile) {
      return 'lg';
    }
    const showSmallPrice = sellingPrice >= 1000000 || sellingPrice >= 100000 && type === 'Deal';
    return showSmallPrice ? 'sm' : 'md';
  };

  return (
    <Container
      disableVerticalPadding={disableVerticalPadding}
      gap={{
        laptop: '26 19',
        mobile: '20 13',
      }}
    >
      { storeItemList.map((storeItem, index) => (
        <StyledGridItem
          key={storeItem.id}
          column={{
            laptop: 4,
          }}
        >
          <ExhibitionProductCard
            product={storeItem}
            badgeType={badgeType}
            textBadgeList={storeItem.textBadgeList}
            useBuyButton={useBuyButton}
            href={storeItem.getStoreItemHref?.(storeItem.id)}
            linkComponent={storeItem.linkComponent}
            variant={getVariant(storeItem.sellingPrice, storeItem.type ?? 'Production')}
            showReview={!isMobile}
            logData={{
              ...logData,
              index,
            }}
          />
        </StyledGridItem>
      )) }
    </Container>
  );
}

const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'disableVerticalPadding',
})<{ disableVerticalPadding?: boolean }>`
  padding: ${(props) => props.disableVerticalPadding ? 0 : '10px 0'};
  overflow: visible;
  > div:first-of-type {
    display: flex;
    flex-wrap: wrap;
  }
  ${MEDIA_QUERY.max('tablet', `
    padding: 10px 16px;
    overflow: hidden;
  `)}
`;

const StyledGridItem = styled(GridItem)`
  width: calc(100% / 3);
  ${MEDIA_QUERY.max('laptop', css`
    width: calc(100% / 3);
  `)}
`;
